var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scope-written"
  }, [_c('div', {
    staticClass: "box-shadow-small border-radius"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', {
    staticClass: "mt-10"
  }, [_c('router-link', {
    attrs: {
      "to": "/written"
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  }), _vm._v("返回笔试列表")])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "pull-right hide",
    attrs: {
      "type": "warning",
      "plain": true,
      "icon": "el-icon-my-youjian color-warning"
    }
  }, [_vm._v("\n                    通知面试官\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [_c('el-row', {
    staticClass: "text-center multi-setting"
  }, [_c('el-col', {
    attrs: {
      "span": 8,
      "offset": 15
    }
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("评估人")]), _vm._v(" "), _c('div', [_c('search-down-list', {
    ref: "topInterviewer",
    staticStyle: {
      "width": "60%",
      "display": "inline-block"
    },
    attrs: {
      "holder": "评估人"
    },
    model: {
      value: (_vm.topObj.masterInterviewer),
      callback: function($$v) {
        _vm.$set(_vm.topObj, "masterInterviewer", $$v)
      },
      expression: "topObj.masterInterviewer"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "betch-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.setBetchCol('masterInterviewer')
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm mt-20",
    attrs: {
      "model": _vm.dynamicForm
    }
  }, [_c('el-table', {
    ref: "recommendTable",
    attrs: {
      "data": _vm.dynamicForm.lists
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "候选人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.name) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "手机号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.phone) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职位",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.positionName) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "笔试答卷",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.examName || '-') + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "评估人",
      "align": "center",
      "min-width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          staticStyle: {
            "margin-top": "5px"
          }
        }, [_c('search-down-list', {
          ref: ("userSelects-" + (scope.row.id)),
          attrs: {
            "cacheOptions": scope.row.markList
          },
          model: {
            value: (scope.row.markIds),
            callback: function($$v) {
              _vm.$set(scope.row, "markIds", $$v)
            },
            expression: "scope.row.markIds"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.removeRow(scope.row.id, scope.$index)
            }
          }
        }, [_vm._v("移除")])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-10"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelAndBack
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.idsLength === 0
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1df79ac3"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/written/writtenRecommend.vue
// module id = null
// module chunks = 